export default __webpack_public_path__ + "static/media/portfolio-129.161e45f9.jpg";